import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import HorizontalRule from '@teladoc/pulse/ui/HorizontalRule';
import {useL10nDateTimeContext} from '@teladoc/pulse/ui/Context/l10n/DateTime';
import useTransLoader from 'i18n/use-trans-loader';
import SessionDateUtil from '../../utils/session-date-util';
import css from './SmallView.scss';

const SmallView = ({appointmentData, coachingSession}) => {
    const {t} = useTransLoader('confirmation');
    const {enableAxleForm} = useSelector(state => state.userData.featureFlags);
    const {intlFormat} = useL10nDateTimeContext();
    let type = appointmentData?.type;

    if (!type) {
        type = enableAxleForm
            ? coachingSession?.type
            : coachingSession?.reason?.reasonDesc;
    }

    return (
        <div className={css.root}>
            <section className={css.section}>
                <div className={css.descriptionStatus}>
                    <span>{t('sessionScheduledCoach')}</span>
                </div>
                <div className={css.statusCode}>
                    <span>
                        {SessionDateUtil.getCoachName(
                            coachingSession,
                            appointmentData,
                            enableAxleForm
                        )}
                    </span>
                </div>
            </section>
            <HorizontalRule spaceTop={50} spaceBottom={50} />
            <section className={css.section}>
                <div className={css.descriptionStatus}>
                    <span>{t('date')}</span>
                </div>
                <div className={css.statusCode}>
                    <span>
                        {SessionDateUtil.getScheduledDate(
                            coachingSession,
                            appointmentData,
                            2,
                            intlFormat,
                            enableAxleForm
                        )}
                    </span>
                </div>
            </section>
            <HorizontalRule spaceTop={50} spaceBottom={50} />
            <section className={css.section}>
                <div className={css.descriptionStatus}>{t('time')}</div>
                <div className={css.statusCode}>
                    {SessionDateUtil.getScheduledTime(
                        coachingSession,
                        appointmentData,
                        intlFormat,
                        enableAxleForm
                    )}
                </div>
            </section>
            <HorizontalRule spaceTop={15} spaceBottom={15} />
            <section className={css.section}>
                <div className={css.descriptionStatus}>
                    {t('sessionScheduledType')}
                </div>
                <div className={css.statusCode}>
                    {enableAxleForm
                        ? type
                        : t(SessionDateUtil.getCallTypeV2(type))}
                </div>
            </section>
            <HorizontalRule spaceTop={15} spaceBottom={15} />
            <section className={css.section}>
                <div className={css.descriptionStatus}>
                    {t('sessionScheduledMethod')}
                </div>
                <div className={css.statusCode}>
                    <div>
                        <div>{t('phoneCall')}</div>
                        <div>{t('callFrom')}</div>
                    </div>
                </div>
            </section>
        </div>
    );
};

SmallView.propTypes = {
    appointmentData: PropTypes.object,
    coachingSession: PropTypes.object,
};

export default SmallView;
